import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UiModule } from 'src/app/ui/ui.module';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';
import { DateLineFormatViewModel } from './date-line-format.view-model';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
@Component({
	selector: 'app-date-line-format',
	imports: [UiModule, AtomicModule, FormsModule, NgIf],
	templateUrl: './date-line-format.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DateLineFormatViewModel],
})
export class DateLineFormatComponent {
	vm = inject(DateLineFormatViewModel);
}
